import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import firstone from '../../assets/images/news/news1.png';
import secondone from '../../assets/images/news/news2.png';
import thirdone from '../../assets/images/news/news3.png';
import Paginationn from "../pagination/paginationn";

import "./news_styles/newslower.css";
const array = [
  {
    image: firstone,
    date: "12/28/2022",
    para: `The recently popular Internet AI: ChatGPT has actually written:
    "The Plan to Destroy Humanity"`,
    Detail: "Detail",
  },
  {
    image: secondone,
    date: "12/28/2022",
    para: `The recently popular Internet AI: ChatGPT has actually written:
    "The Plan to Destroy Humanity"`,
    Detail: "Detail",
  },
  {
    image: thirdone,
    date: "12/28/2022",
    para: `The recently popular Internet AI: ChatGPT has actually written:
    "The Plan to Destroy Humanity"`,
    Detail: "Detail",
  },
  {
    image: firstone,
    date: "12/28/2022",
    para: `The recently popular Internet AI: ChatGPT has actually written:
    "The Plan to Destroy Humanity"`,
    Detail: "Detail",
  },
  {
    image: secondone,
    date: "12/28/2022",
    para: `The recently popular Internet AI: ChatGPT has actually written:
    "The Plan to Destroy Humanity"`,
    Detail: "Detail",
  },
  {
    image: thirdone,
    date: "12/28/2022",
    para: `The recently popular Internet AI: ChatGPT has actually written:
    "The Plan to Destroy Humanity"`,
    Detail: "Detail",
  },
];
export default function NewsLower() {
  return (
    <>
      <Container className="mt-3 mb-3 news_lower">
        <Row className="p-3 m-3">
          {array.map((item) => {
            return (
              <Col lg={4} className="mt-3">
                <div className="card">
                  <div className="news_lower_image">
                    <img
                      src={item.image}
                      alt="first one"
                      className="news_lower_img img-fluid"
                    />
                  </div>
                  <div className="d-flex justify-content-start">
                    <p className="text-justify">{item.para}</p>
                  </div>
                  <a href="">{item.Detail}</a>
                </div>
              </Col>
            );
          })}
           <div className="mt-5">
            <Paginationn />
           </div>
                  </Row>
      </Container>
    </>
  );
}
